import { useState, useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/hooks/useAuth';
import { UserResult } from '@/types/search';

export function useMentionSearch() {
  const [users, setUsers] = useState<UserResult[]>([]);
  const [loading, setLoading] = useState(false);
  const { user } = useAuth();

  const searchUsers = useCallback(async (query: string) => {
    if (!query.trim() || !user) {
      setUsers([]);
      return;
    }

    setLoading(true);
    try {
      // Search for users matching the query
      const { data, error } = await supabase
        .rpc('search_public_profiles', {
          search_term: query,
          excluding_user_id: user.id
        })
        .limit(10);

      if (error) throw error;

      setUsers(data || []);
    } catch (error) {
      console.error('Error searching users:', error);
      setUsers([]);
    } finally {
      setLoading(false);
    }
  }, [user]);

  return { searchUsers, users, loading };
}
